// Self-contained Sudoku generator & solver (no external services).
// Board is a flat array of length 81; 0 means empty.

const idx = (r, c) => r * 9 + c;

function isValid(board, pos, val) {
  const r = Math.floor(pos / 9);
  const c = pos % 9;
  for (let i = 0; i < 9; i++) {
    if (board[idx(r, i)] === val) return false;
    if (board[idx(i, c)] === val) return false;
  }
  const br = Math.floor(r / 3) * 3;
  const bc = Math.floor(c / 3) * 3;
  for (let i = 0; i < 3; i++)
    for (let j = 0; j < 3; j++)
      if (board[idx(br + i, bc + j)] === val) return false;
  return true;
}

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

function fillBoard(board) {
  const pos = board.indexOf(0);
  if (pos === -1) return true;
  for (const val of shuffle([1, 2, 3, 4, 5, 6, 7, 8, 9])) {
    if (isValid(board, pos, val)) {
      board[pos] = val;
      if (fillBoard(board)) return true;
      board[pos] = 0;
    }
  }
  return false;
}

function countSolutions(board, limit = 2) {
  const pos = board.indexOf(0);
  if (pos === -1) return 1;
  let count = 0;
  for (let val = 1; val <= 9; val++) {
    if (isValid(board, pos, val)) {
      board[pos] = val;
      count += countSolutions(board, limit);
      board[pos] = 0;
      if (count >= limit) break;
    }
  }
  return count;
}

const REMOVE = { mudah: 40, sedang: 50, sulit: 54 };

export function generatePuzzle(difficulty = "mudah") {
  const solution = new Array(81).fill(0);
  fillBoard(solution);
  const puzzle = solution.slice();
  const target = REMOVE[difficulty] ?? 40;
  const order = shuffle([...Array(81).keys()]);
  let removed = 0;
  for (const p of order) {
    if (removed >= target) break;
    const backup = puzzle[p];
    if (backup === 0) continue;
    puzzle[p] = 0;
    const test = puzzle.slice();
    if (countSolutions(test, 2) !== 1) {
      puzzle[p] = backup; // keep unique solution
    } else {
      removed++;
    }
  }
  return { puzzle, solution };
}

export function formatTime(sec) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
